<template>
    <div class="tpl-content-wrapper ">
        <div class="tpl-portlet-components">
            <div class="tpl-portlet-title" style="border-bottom: none">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>收藏列表</span>
                </div>
            </div>
            <ul class="nav_title_ul">
                <li class="nav_title_li"
                    :class="nav_title==='课程' ? 'active_nav' : ''"
                    @click="tab_nav('课程')"
                >
                    课程
                </li>
                <li class="nav_title_li"
                    :class="nav_title==='文章' ? 'active_nav' : ''"
                    @click="tab_nav('文章')"
                >
                    文章
                </li>
                <li class="nav_title_li"
                    :class="nav_title==='提问' ? 'active_nav' : ''"
                    @click="tab_nav('提问')"
                >
                    提问
                </li>
            </ul>
            <div class="stuff_div">
                <keep-alive>
                    <component :is="stuff_component_dict[nav_title]"></component>
                </keep-alive>
            </div>
            <!--<div class="tpl-portlet-content">-->
            <!--<div class="qa_item_div" v-for="user in followed_results" :key="user['id']">-->
            <!--<div class="qa_item_question_div">-->
            <!--<router-link tag="a" :to="{ name: 'user', params: { id: user.id } }">-->
            <!--<img :src="user.avatar_url"-->
            <!--class="item_question_avatar"/>-->
            <!--</router-link>-->
            <!--<div class="item_question">-->
            <!--<router-link :to="{ name: 'user', params: { id: user.id } }" tag="a"-->
            <!--class="item_question_title">-->
            <!--{{user.name}}-->
            <!--</router-link>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="item_view_answer_div">-->
            <!--<div class="view_answer_div view_number_div">-->
            <!--<span class="answer_span view_answer_span">{{user.follower_count}}</span>-->
            <!--<span class="answer_span view_answer_span">粉丝</span>-->
            <!--</div>-->

            <!--<div class="view_answer_div view_number_div" style="padding: 10px">-->
            <!--<a v-if="user.login_user_follow_state" class="answer_span view_answer_span"-->
            <!--@click="change_follow_state(user.id,'do_no')"-->
            <!--style="text-decoration: underline;color: #66CCFF">取消关注</a>-->
            <!--<a v-else class="answer_span view_answer_span"-->
            <!--@click="change_follow_state(user.id,'do_ok')"-->
            <!--style="text-decoration: underline;color: #66CCFF">加关注</a>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
        </div>

    </div>
</template>

<script>
    import UserApi from '@/api/user/user.js'
    import {mapState, mapGetters, mapActions} from 'vuex'
    import Courses from './collect_sub_components/courses.vue'
    import Posts from './collect_sub_components/posts.vue'
    import Questions from './collect_sub_components/questions.vue'

    export default {
        name: "follow_main",
        data: function () {
            return {
                followed_results: [],
                nav_title: '课程',
                stuff_component_dict: {
                    '课程': 'Courses',
                    '文章': 'Posts',
                    '提问': 'Questions'
                }

            }
        },
        components: {
            Courses,
            Posts,
            Questions
        },
        computed: {
            ...mapState({
                login_user_id: state => state.loginState.user_info.id,
            }),
            ...mapGetters({}),
        },
        methods: {
            ...mapActions({}),
            async change_follow_state(user_id, action) {
                let vals = {
                    user_id: user_id,
                    follow_state: true,
                }
                if (action === 'do_ok') {
                    vals.follow_state = false
                }
                UserApi.change_follow_state(vals).then((res) => {
                    let data = JSON.parse(res.data.result);
                    if (data.code == 'success') {
                        let index
                        for (let i = 0; i < this.followed_results.length; i++) {
                            if (this.followed_results[i].id === user_id) {
                                index = i
                                break
                            }
                        }
                        this.followed_results[index].login_user_follow_state = data.login_user_follow_state
                    }
                })
            },
            tab_nav(nav_title) {
                this.nav_title = nav_title
            }
        },
        mounted() {
            UserApi.get_user_follower({'id': this.login_user_id}).then((res) => {
                this.followed_results = res.data.followed;
            })
        }
    }
</script>

<style scoped>
    .nav_title_ul {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    .nav_title_li {
        font-size: 16px;
        padding: 3px 5px;
        padding-bottom: 7px;
        margin-right: 25px;
        margin-bottom: -1px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }

    .active_nav {
        border-bottom-color: #66CCFF;;
    }

    .tpl-portlet-content {
        height: 455px;
        overflow: auto
        /*background: red;*/
    }

    .qa_item_div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #eee;
    }

    .qa_item_question_div {
        display: flex;
        width: 83%;
    }

    .item_question {
        display: flex;
        flex-direction: column;
        padding: 0 15px;
        max-width: 83%;
        /*max-width: 600px;*/
    }

    .item_question_avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        /*margin-left: 15px;*/
        /*margin-top: 36px;*/
    }

    .item_question_title {
        display: inline-block;
        white-space: nowrap;
        font-size: 18px;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #0181da;
        max-width: 100%;
        padding: 10px;
        font-weight: bold
    }

    .item_view_answer_div {
        display: flex;
        width: 16%;
        /*margin: 0 30px;*/
        padding: 0 15px;
        justify-content: space-around;
    }

    .view_answer_div {
        display: flex;
        flex-direction: column;
        /*margin-right: 5px;*/
    }

    .view_answer_span {
        font-size: 14px;
        text-align: center;
    }

</style>